import { CommonModule } from "@angular/common";
import { Component, computed, inject, input } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { IonicModule } from "@ionic/angular";
import { TranslateModule, TranslateService } from "@ngx-translate/core";
import { FreeBetAvailableDepositFbFormatted, FreeBetData } from "@sports-pages/ticket/models";
import { FreeBetsAvailable } from "./components/free-bets-available/free-bets-available.component";
import { FreeBetsEmpty } from "./components/free-bets-empty/free-bets-empty.component";
import { FreeBetsInstructions } from "./components/free-bets-instructions/free-bets-instructions.component";
import { FreeBetsTotal } from "./components/free-bets-totals/free-bets-total.component";
import { TipoFreeBet } from "./components/tipo-free-bet/tipo-free-bet";

@Component({
  standalone: true,
  selector: "free-bets-info",
  templateUrl: "free-bets-info.component.html",
  styleUrls: ["free-bets-info.component.scss"],
  imports: [
    IonicModule,
    CommonModule,
    TranslateModule,
    ReactiveFormsModule,
    FormsModule,
    TipoFreeBet,
    FreeBetsTotal,
    FreeBetsEmpty,
    FreeBetsInstructions,
    FreeBetsAvailable,
  ],
})
export class FreeBetsInfo {
  aPendingFB = input.required<FreeBetAvailableDepositFbFormatted[]>();
  activeFB = input.required<FreeBetData[]>();
  licenseType = input.required<number>();
  firstLoad = input.required<boolean>();
  isMobile = input.required<boolean>();
  isFbOnline = input.required<boolean>();
  hasAPendingFB = computed(() => !!this.aPendingFB()?.length);
  hasActiveFB = computed(() => !!this.activeFB()?.length);
  showEmptyState = computed(() => !this.hasAPendingFB() && !this.hasActiveFB() && !this.firstLoad());
  hasFB = computed(() => this.hasAPendingFB() || this.hasActiveFB());

  indexSeeMorePend: number;

  translate = inject(TranslateService);

  constructor() {
    this.indexSeeMorePend = 0;
  }

  showMoreFreeBet() {
    this.indexSeeMorePend = this.indexSeeMorePend + 1;
  }
}
